import React, { useState, useEffect } from "react";
import { useTranslation } from "../i18n";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  Rectangle,
  Tooltip,
  useMap,
} from "react-leaflet";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import "./Anreise.css";

// Fix Leaflet default icon issue
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

function Anreise({ isOneDay = false }) {
  const { t } = useTranslation();
  const [openPopups, setOpenPopups] = useState(isOneDay ? new Set(["milo", "milo_station1"]) : new Set());
  const [hoveredLocation, setHoveredLocation] = useState(null);
  const [activeLocation, setActiveLocation] = useState("grabkapelle"); // Keep track of last selected location
  
  // Determine zoom level based on screen size
  const [zoomLevel, setZoomLevel] = useState(17);
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setZoomLevel(mobile ? 15 : 17); // Zoom out more on mobile to show S-Bahn station
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Location data based on isOneDay prop
  const locations = isOneDay
    ? [
        {
          id: "milo",
          position: [48.810911, 9.414003], // MILO Hölzlestraße 17, 73630 Remshalden
          nameKey: "anreise.locationOneDay.name",
          addressKey: "anreise.locationOneDay.address",
          cityKey: "anreise.locationOneDay.city",
          titleKey: "anreise.locationOneDay.title",
          parkingAreas: [
            {
              id: "beutelsbacher_strasse_1",
              positions: [
                [48.810883, 9.413621], // Start
                [48.810564, 9.414558], // End
              ],
              nameKey: "anreise.parking.beutelsbacher",
              capacityKey: "anreise.parking.limited",
              costKey: "anreise.parking.free",
              surfaceKey: "anreise.parking.street",
            },
            {
              id: "beutelsbacher_strasse_2",
              positions: [
                [48.811239, 9.411688], // Start
                [48.810995, 9.413204], // End
              ],
              nameKey: "anreise.parking.beutelsbacher",
              capacityKey: "anreise.parking.limited",
              costKey: "anreise.parking.free",
              surfaceKey: "anreise.parking.street",
            },
            {
              id: "beutelsbacher_strasse_3",
              positions: [
                [48.811181, 9.412941], // Start
                [48.811131, 9.413362], // End
              ],
              nameKey: "anreise.parking.beutelsbacher",
              capacityKey: "anreise.parking.limited",
              costKey: "anreise.parking.free",
              surfaceKey: "anreise.parking.street",
            },
            {
              id: "hoelzle_strasse",
              positions: [
                [48.811077, 9.413793], // Left start
                [48.810941, 9.414866], // Right end
              ],
              nameKey: "anreise.parking.hoelzle",
              capacityKey: "anreise.parking.limited",
              costKey: "anreise.parking.free",
              surfaceKey: "anreise.parking.street",
            },
          ],
          transportStations: [
            {
              id: "milo_station1",
              position: [48.810396, 9.419598],
              nameKey: "anreise.transport.sbahn",
              linesKey: "anreise.transport.sLines",
              walkingTimeKey: "anreise.transport.sWalk",
            },
          ],
        },
      ]
    : [
    {
      id: "grabkapelle",
      position: [48.781261, 9.268971], // Grabkapelle auf dem Württemberg
          nameKey: "anreise.location.name",
          addressKey: "anreise.location.address",
          cityKey: "anreise.location.city",
          titleKey: "anreise.location.title",
      parkingAreas: [],
          transportStations: [],
        },
    {
      id: "waldschloessle",
      position: [48.797645, 9.285043], // Restaurant Waldschlössle in Fellbach
          nameKey: "anreise.locationWaldschloessle.name",
          addressKey: "anreise.locationWaldschloessle.address",
          cityKey: "anreise.locationWaldschloessle.city",
          titleKey: "anreise.locationWaldschloessle.title",
          parkingAreas: [],
          transportStations: [],
        },
    {
      id: "milo",
      position: [48.810911, 9.414003], // MILO Remshalden
      nameKey: "anreise.locationOneDay.name",
      addressKey: "anreise.locationOneDay.address",
      cityKey: "anreise.locationOneDay.city",
      titleKey: "anreise.locationOneDay.title",
      parkingAreas: [
        {
          id: "beutelsbacher_strasse_1",
          positions: [
            [48.810883, 9.413621], // Start
            [48.810564, 9.414558], // End
          ],
          nameKey: "anreise.parking.beutelsbacher",
          capacityKey: "anreise.parking.limited",
          costKey: "anreise.parking.free",
          surfaceKey: "anreise.parking.street",
        },
        {
          id: "beutelsbacher_strasse_2",
          positions: [
            [48.811239, 9.411688], // Start
            [48.810995, 9.413204], // End
          ],
          nameKey: "anreise.parking.beutelsbacher",
          capacityKey: "anreise.parking.limited",
          costKey: "anreise.parking.free",
          surfaceKey: "anreise.parking.street",
        },
        {
          id: "beutelsbacher_strasse_3",
          positions: [
            [48.811181, 9.412941], // Start
            [48.811131, 9.413362], // End
          ],
          nameKey: "anreise.parking.beutelsbacher",
          capacityKey: "anreise.parking.limited",
          costKey: "anreise.parking.free",
          surfaceKey: "anreise.parking.street",
        },
        {
          id: "hoelzle_strasse",
          positions: [
            [48.811077, 9.413793], // Left start
            [48.810941, 9.414866], // Right end
          ],
          nameKey: "anreise.parking.hoelzle",
          capacityKey: "anreise.parking.limited",
          costKey: "anreise.parking.free",
          surfaceKey: "anreise.parking.street",
        },
      ],
      transportStations: [
        {
          id: "milo_station1",
          position: [48.810396, 9.419598],
          nameKey: "anreise.transport.sbahn",
          linesKey: "anreise.transport.sLines",
          walkingTimeKey: "anreise.transport.sWalk",
        },
      ],
    },
      ];

  // Use hovered location for center position, fallback to active location for 2-day
  const hoveredLocationData = hoveredLocation ? locations.find(loc => loc.id === hoveredLocation) : null;
  const activeLocationData = locations.find(loc => loc.id === activeLocation);
  const centerPosition = isOneDay ? [48.8105, 9.416] : (hoveredLocationData ? hoveredLocationData.position : activeLocationData.position);

  // Hotels (same for both locations)
  const hotels = [];

  // Custom icons
  const createCustomIcon = (color, symbol) =>
    new Icon({
      iconUrl: `data:image/svg+xml;base64,${btoa(
        `
      <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="12" fill="${color}" stroke="#fff" stroke-width="2"/>
        <text x="16" y="20" text-anchor="middle" fill="white" font-size="12" font-weight="bold">${symbol}</text>
      </svg>
    `.replace(/[\u{0080}-\u{FFFF}]/gu, "")
      )}`,
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });

  // Parking sign icon only
  const createParkingIcon = () =>
    new Icon({
      iconUrl: `data:image/svg+xml;base64,${btoa(
        `
        <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="4" width="24" height="32" rx="4" fill="#0066cc" stroke="#003d7a" stroke-width="2"/>
          <rect x="12" y="8" width="16" height="20" rx="2" fill="white"/>
          <text x="20" y="22" text-anchor="middle" fill="#0066cc" font-size="14" font-weight="bold" font-family="Arial, sans-serif">P</text>
        </svg>
      `.replace(/[\u{0080}-\u{FFFF}]/gu, "")
      )}`,
      iconSize: [40, 40],
      iconAnchor: [20, 20],
      popupAnchor: [0, -20],
    });

  // Text icon with integrated parking symbol
  const createTextIcon = (text, rotate = false) =>
    new Icon({
      iconUrl: `data:image/svg+xml;base64,${btoa(`
        <svg width="200" height="30" viewBox="0 0 200 30" xmlns="http://www.w3.org/2000/svg">
          ${rotate ? '<g transform="rotate(15 100 15)">' : ''}
          <rect x="5" y="5" width="190" height="20" rx="10" fill="white" stroke="#0066cc" stroke-width="2"/>
          <rect x="10" y="8" width="14" height="14" rx="2" fill="#0066cc"/>
          <text x="17" y="18" text-anchor="middle" fill="white" font-size="10" font-weight="bold" font-family="Arial, sans-serif">P</text>
          <text x="30" y="18" fill="#0066cc" font-size="12" font-weight="bold" font-family="Arial, sans-serif">${text}</text>
          ${rotate ? '</g>' : ''}
        </svg>
      `.replace(/[\u{0080}-\u{FFFF}]/gu, "")
      )}`,
      iconSize: [200, 30],
      iconAnchor: [100, 15],
      popupAnchor: [0, -15],
    });

  const venueIcon = createCustomIcon("#d9d8c8", "M");
  const transportIcon = createCustomIcon("#4a90e2", "S");
  const hotelIcon = createCustomIcon("#f39c12", "H");

  // Component to handle map view changes
  const MapController = () => {
    const map = useMap();
    
    useEffect(() => {
      if (!isOneDay && hoveredLocationData) {
        map.setView(hoveredLocationData.position, zoomLevel);
      }
    }, [hoveredLocation, hoveredLocationData, isOneDay, map, zoomLevel]);
    
    return null;
  };

  // Set default open popups
  useEffect(() => {
    if (isOneDay) {
      setOpenPopups(new Set(["milo", "milo_station1"]));
    }
  }, [isOneDay]);

  // Initialize with MILO popup open for one-day mode
  const initialOpenPopups = isOneDay ? new Set(["milo", "milo_station1"]) : new Set();

  return (
    <section className="anreise-section">
      <div className="anreise-header">
        <h2 className="anreise-title">{t("anreise.title")}</h2>
        <p className="anreise-subtitle">{t("anreise.subtitle")}</p>
      </div>

      <div className="anreise-content">
        <div className="anreise-map">
          <MapContainer
            center={centerPosition}
            zoom={zoomLevel}
            style={{ height: "500px", width: "100%" }}
            scrollWheelZoom={false}
            attributionControl={false}
          >
            <MapController />
            {/* Satellite imagery layer */}
            <TileLayer
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              attribution='&copy; <a href="https://www.esri.com/">Esri</a>'
            />

            {/* Location markers */}
            {locations.map((location) => {
              let locationIcon = venueIcon;
              if (location.id === "waldschloessle") {
                locationIcon = createCustomIcon("#d9d8c8", "W");
              } else if (location.id === "grabkapelle") {
                locationIcon = createCustomIcon("#d9d8c8", "P");
              }
              
              return (
                <Marker
                  key={location.id}
                  position={location.position}
                  icon={locationIcon}
                >
                  <Popup open={openPopups.has(location.id)}>
                    <div className="popup-content">
                      <h3>{t(location.titleKey)}</h3>
                      <p>
                        <strong>{t(location.nameKey)}</strong>
                      </p>
                      <p>{t(location.addressKey)}</p>
                      <p>{t(location.cityKey)}</p>
                    </div>
                  </Popup>
                </Marker>
              );
            })}

            {/* Parking areas - different rendering for bounds (2-day) vs positions (1-day) */}
            {locations
              .filter((location) => isOneDay || !hoveredLocation || location.id === hoveredLocation)
              .flatMap((location) => location.parkingAreas)
              .map((parking) => {
                if (parking.positions) {
                  // 1-day version: street parking with polylines
                  const startPoint = parking.positions[0];
                  const endPoint = parking.positions[1];
                  const midPoint = [
                    (startPoint[0] + endPoint[0]) / 2,
                    (startPoint[1] + endPoint[1]) / 2,
                  ];
                  
                  const offset = parking.nameKey === "anreise.parking.hoelzle" ? 0.0002 : -0.0002;
                  const textPosition = [midPoint[0] + offset, midPoint[1]];
                  const arrowOffset = parking.nameKey === "anreise.parking.hoelzle" ? 0.0001 : -0.0001;
                  const arrowEndPosition = [midPoint[0] + arrowOffset, midPoint[1]];
                  
                  return (
                    <React.Fragment key={parking.id}>
                      <Polyline
                        positions={parking.positions}
                        pathOptions={{
                          color: "#0066cc",
                          weight: 10,
                          opacity: 0.8,
                          dashArray: "15, 8",
                        }}
                      />
                      <Polyline
                        positions={[textPosition, arrowEndPosition]}
                        pathOptions={{
                          color: "#0066cc",
                          weight: 2,
                          opacity: 0.6,
                        }}
                      />
                      <Marker position={textPosition} icon={createParkingIcon()} />
                    </React.Fragment>
                  );
                } else if (parking.bounds) {
                  // 2-day version: meadow parking with rectangles
                  return (
                    <React.Fragment key={parking.id}>
                      <Rectangle
                        bounds={parking.bounds}
                        pathOptions={{
                          color: "#0066cc",
                          weight: 3,
                          opacity: 0.8,
                          fillColor: "#0066cc",
                          fillOpacity: 0.3,
                        }}
                      />
                      <Marker 
                        position={[
                          (parking.bounds[0][0] + parking.bounds[1][0]) / 2,
                          (parking.bounds[0][1] + parking.bounds[1][1]) / 2
                        ]} 
                        icon={createTextIcon(t(parking.nameKey), false)} 
                      />
                    </React.Fragment>
                  );
                }
                return null;
              })}

            {/* Transport stations */}
            {locations
              .filter((location) => isOneDay || !hoveredLocation || location.id === hoveredLocation)
              .flatMap((location) => location.transportStations)
              .map((station) => (
                <Marker
                  key={station.id}
                  position={station.position}
                  icon={transportIcon}
                >
                  <Popup open={openPopups.has(station.id)}>
                    <div className="popup-content">
                      <h3>{t(station.nameKey)}</h3>
                      <p>
                        <strong>{t('anreise.transport.walk')}</strong> {t(station.walkingTimeKey)}
                      </p>
                    </div>
                  </Popup>
                </Marker>
              ))}

            {/* Hotels */}
            {hotels.map((hotel) => (
              <Marker key={hotel.id} position={hotel.position} icon={hotelIcon}>
                <Popup>
                  <div className="popup-content">
                    <h3>{hotel.name}</h3>
                    <p>
                      <strong>{t("anreise.hotels.distance")}</strong>{" "}
                      {hotel.distance}
                    </p>
                    <p>
                      <strong>{t("anreise.hotels.rating")}</strong>{" "}
                      {hotel.rating}
                    </p>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>

        <div className="anreise-info">
          <div className="info-cards">
            {/* Location cards */}
            {locations.map((location) => (
              <div 
                key={location.id} 
                className="info-card"
                onMouseEnter={() => {
                  if (!isOneDay) {
                    setHoveredLocation(location.id);
                    setActiveLocation(location.id);
                  }
                }}
                onMouseLeave={() => !isOneDay && setHoveredLocation(null)}
              >
                <h3>{t(location.titleKey)}</h3>
                <p>
                  <strong>{t(location.nameKey)}</strong>
                </p>
                <p>{t(location.addressKey)}</p>
                <p>{t(location.cityKey)}</p>
              </div>
            ))}

            {/* Parking card */}
            <div className="info-card">
              <h3>{t("anreise.parking.options")}</h3>
              {isOneDay ? (
                <div>
                  <p>
                    <strong>{t("anreise.parking.titleOneDay")}</strong>
                  </p>
                  <p>{t("anreise.parking.descriptionOneDay")}</p>
                </div>
               ) : (
                 <div>
                   <p><strong>{t("anreise.parking.labelGrabkapelle")}</strong> {t("anreise.parking.grabkapelle")}</p>
                   <p><strong>{t("anreise.parking.labelWaldschloessle")}</strong> {t("anreise.parking.waldschloessle")}</p>
                   <p><strong>{t("anreise.parking.labelMilo")}</strong> {t("anreise.parking.milo")}</p>
                 </div>
               )}
            </div>

            {/* Transport card */}
            <div className="info-card">
              <h3>{t("anreise.transport.title")}</h3>
              <p>
                <strong>{t("anreise.transport.sbahn")}</strong> (
                {t("anreise.transport.sWalk")})
              </p>
            </div>

            {/* Hotels card */}
            <div className="info-card">
              <h3>{t("anreise.hotels.title")}</h3>
              <p>{t("anreise.hotels.recommendation")}</p>
              <p>
                <a
                  href="https://achat-hotels.com/hotels/waiblingen-loginn"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("anreise.hotels.cta")}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Anreise;
